import type { FormField, FormSchema } from '@cli-types/core-engine/schema.js'

export function hasDynamicFields(schema: FormSchema): boolean {
  const check = (fields: FormField[]): boolean => {
    for (const f of fields) {
      if (f.type === 'dynamicFields') return true
      if (f.type === 'group' && f.fields && check(f.fields)) return true
    }
    return false
  }
  if (schema.fields && check(schema.fields)) return true
  if (schema.steps) {
    for (const step of schema.steps) {
      if (check(step.fields)) return true
    }
  }
  return false
}
